import { ButtonTypeTokens, IconTokens, StepperStateToken, } from '@voltmoney/schema';
import { ACTION, } from './types';
import { ROUTE } from '../../../routes';
import SharedPropsService from '../../../SharedPropsService';
import _ from 'lodash';
import { api } from '../../../configs/api';
import { APP_CONFIG, getAppHeader } from '../../../configs/config';
import { nextStepCredStepper, updateCurrentStepId, updateStepStatusMap, } from '../../../configs/utils';
import AsyncStorage from "@react-native-async-storage/async-storage";
let bankAccountNumber = '';
let bankIfsc = '';
let hasNavigated;
export const NavigationSearchIFSCAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.BANK_SEARCH_BRANCH, {
        bankCode: action.payload.bankCode,
        bankName: action.payload.bankName,
        bankAccountNumber,
    });
};
export const moveToBankScreen = async (action, _datastore, { navigateWithClear }) => {
    await navigateWithClear(ROUTE.BANK_SELECT);
};
export const onChangeAccountNumber = async (action, _datastore, { ...props }) => {
    bankAccountNumber = action.payload.value;
    await SharedPropsService.setAccountNumber(bankAccountNumber);
    await ToggleCTA(action, _datastore, props);
};
export const onChangeIFSCNumber = async (action, _datastore, { ...props }) => {
    bankIfsc = action.payload.value;
    await ToggleCTA(action, _datastore, props);
};
export const ToggleCTA = async (action, _datastore, { setDatastore }) => {
    if (bankAccountNumber && bankIfsc) {
        await setDatastore(action.routeId, action.payload.targetWidgetId, {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    else {
        await setDatastore(action.routeId, action.payload.targetWidgetId, {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
};
export const skipBank = async (action, _datastore, { setDatastore, navigate, navigateToBase, network }) => {
    var bc = await SharedPropsService.getAccountNumber();
    var ifscNum = await SharedPropsService.getIfsc();
    const user = await SharedPropsService.getUser();
    const applicationId = user.linkedApplications[0].applicationId;
    const response = await network.post(api.addBank, {
        applicationId,
        bankAccountNumber: bc,
        bankIfscCode: ifscNum,
        confirmedBankAccountNumber: bc
    }, { headers: await getAppHeader(), handleFromMF: true }, async () => {
        //dismiss modal -> Depositing Rs 1
    });
    if (_.get(response, 'status') === 200) {
        const stepStatusMap = _.get(response, 'data.updatedApplicationObj.stepStatusMap', null);
        const currentStepId = _.get(response, 'data.updatedApplicationObj.currentStepId', null);
        if (currentStepId && stepStatusMap) {
            await updateCurrentStepId(currentStepId);
            await updateStepStatusMap(stepStatusMap);
        }
        const routeObj = await nextStepCredStepper();
        navigateToBase(routeObj.routeId, routeObj.params);
    }
    else {
        await setDatastore(action.routeId, 'st', {
            modalState: 'error',
            errorTitle: `Invalid bank account`,
            errorSubtitle: 'Please verify account details and try again',
            errorModalCtaLabel: 'Add another bank account'
        });
    }
};
export const BavVerifyManualAction = async (action, _datastore, { setDatastore, network, showPopup, navigate, instrumentTrack, navigateToBase }) => {
    var bc = await SharedPropsService.getAccountNumber();
    var ifscNum = await SharedPropsService.getIfsc();
    console.warn("IFSC NUM IS", ifscNum);
    instrumentTrack('VERIFY_BANK_BUTTON_CLICKED');
    await setDatastore(action.routeId, 'st', {
        loading: true,
        modalState: 'penny',
    });
    const user = await SharedPropsService.getUser();
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
    const response = await network.post(api.bavVerify, {
        applicationId,
        bankAccountDetails: {
            bankAccountNumber: bc,
            bankIfscCode: ifscNum,
        },
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (_.get(response, 'status') !== 200) {
        if (response?.response?.data?.statusCode === '500') {
            setTimeout(() => {
                setDatastore(action.routeId, 'st', {
                    modalState: 'error',
                    errorTitle: `${response.response.data.message}`,
                    errorModalCtaLabel: 'Try again',
                    loading: false
                });
            }, 0);
            return;
        }
        const errorCode = response.response.data.voltErrorCode;
        if (errorCode === "KYC_VERIFICATION_FAILED_NAME_MISMATCH") {
            const failureJson = JSON.parse(response.response.data.message);
            const heading = failureJson.nameMatchFailureDetails.description;
            const key1 = failureJson.nameMatchFailureDetails.source.description;
            const value1 = failureJson.nameMatchFailureDetails.source.value;
            const key2 = failureJson.nameMatchFailureDetails.target.description;
            const value2 = failureJson.nameMatchFailureDetails.target.value;
            await navigate(ROUTE.NAME_MISMATCH, {
                heading: heading,
                key1: key1,
                value1: value1,
                key2: key2,
                value2: value2,
                isFromKYC: false,
                ifscCode: ifscNum.substring(0, 4)
            });
        }
        else {
            if (response?.response?.data?.voltErrorCode === "IFSC_INELIGIBLE_FOR_AUTOPAY") {
                setTimeout(() => {
                    setDatastore(action.routeId, 'st', {
                        modalState: 'ifsc',
                        loading: false
                    });
                }, 0);
            }
            else {
                setTimeout(() => {
                    setDatastore(action.routeId, 'st', {
                        modalState: 'error',
                        errorTitle: `Invalid bank account`,
                        errorSubtitle: 'Please verify account details and try again',
                        errorModalCtaLabel: 'Add another bank account',
                        loading: false
                    });
                }, 0);
            }
        }
    }
    else {
        const stepStatusMap = _.get(response, 'data.updatedApplicationObj.stepStatusMap', null);
        const currentStepId = _.get(response, 'data.updatedApplicationObj.currentStepId', null);
        if (currentStepId && stepStatusMap) {
            await updateCurrentStepId(currentStepId);
            await updateStepStatusMap(stepStatusMap);
        }
        console.warn("THIS IS THE VALE OF RESP", stepStatusMap.BANK_ACCOUNT_VERIFICATION);
        if (stepStatusMap.BANK_ACCOUNT_VERIFICATION === StepperStateToken.COMPLETED) {
            const routeObj = await nextStepCredStepper();
            setTimeout(() => {
                if (!hasNavigated) {
                    navigateToBase(routeObj.routeId, routeObj.params);
                }
            }, 5000);
            setTimeout(() => {
                setDatastore(action.routeId, 'st', {
                    modalState: 'success',
                    loading: false
                });
            }, 0);
        }
        else if (stepStatusMap.BANK_ACCOUNT_VERIFICATION ===
            StepperStateToken.PENDING_MANUAL_VERIFICATION) {
            await showPopup({
                autoTriggerTimerInMilliseconds: APP_CONFIG.POLLING_INTERVAL,
                isAutoTriggerCta: false,
                type: 'DEFAULT',
                iconName: IconTokens.InProgress,
                title: 'Verification in progress',
                subTitle: "It's taking longer than usual to verify the account. We'll automatically try again in some time.",
                ctaLabel: 'Continue',
                ctaAction: {
                    type: ACTION.NAV_STEPPER,
                    routeId: ROUTE.BANK_ACCOUNT_ADD,
                    payload: {},
                },
            });
        }
        // await setDatastore(action.routeId, 'st', <ButtonProps>{
        //     loading: false,
        // })
    }
};
export const ChangeBankGoBackAction = async (action, _datastore, { goBack, navigateToBase }) => {
    await SharedPropsService.setIfsc("");
    await navigateToBase(ROUTE.BANK_SELECT);
};
export const BypassValue = async (action, _datastore, { goBack, navigateToBase, network }) => {
};
export const GoToStepper = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const GoNext = async (action, _datastore, { navigateToBase, goBack }) => {
    hasNavigated = true;
    const routeObj = await nextStepCredStepper();
    await navigateToBase(routeObj.routeId, routeObj.params);
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
